var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useSocialLinks } from '../hooks/use-social-links';
import { FacebookFilledIconGlyph, InstagramFilledIconGlyph, LinkedinFilledIconGlyph, TikTokFilledIconGlyph, XFilledIconGlyph, ThreadsFilledIconGlyph, YouTubeFilledIconGlyph, FlickrFilledIconGlyph } from '@shapeable/icons';
import { MenuItem } from './menu-item';
import { useLang } from '../hooks/use-lang';
import { SiteMenuTitle } from '../entities/site-menu-title';
var cls = classNames('share-menu');
export var FollowMenuDefaultProps = {
  order: ['facebook', 'twitter', 'threads', 'linkedin', 'tiktok', 'instagram', 'youtube', 'flickr'],
  showTitle: true
};
var LABELS = {
  "facebook": "Follow us on <b>Facebook</b>",
  "threads": "Follow us on <b>Threads</b>",
  "twitter": "Follow Us on <b>X</b>",
  "linkedin": "Follow Us on <b>LinkedIn</b>",
  "instagram": "Follow Us on <b>Instagram</b>",
  "tiktok": "Follow Us on <b>TikTok</b>",
  "youtube": "Follow Us on <b>Youtube</b>",
  "flickr": "Follow Us on <b>Flickr</b>"
};
var ICONS = {
  facebook: FacebookFilledIconGlyph,
  instagram: InstagramFilledIconGlyph,
  linkedin: LinkedinFilledIconGlyph,
  tiktok: TikTokFilledIconGlyph,
  twitter: XFilledIconGlyph,
  threads: ThreadsFilledIconGlyph,
  youtube: YouTubeFilledIconGlyph,
  flickr: FlickrFilledIconGlyph
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    font-size: 1em;\n  "], ["\n    width: 100%;\n    font-size: 1em;\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "], ["\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled(MenuItem)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles)
};
/* @ts-ignore */
export var FollowMenu = React.forwardRef(function (props, ref) {
  var className = props.className,
    showTitle = props.showTitle,
    _a = props.order,
    order = _a === void 0 ? [] : _a,
    onItemClick = props.onItemClick;
  var links = useSocialLinks();
  var t = useLang();
  var handleClick = function (e) {
    if (onItemClick) {
      onItemClick();
    }
  };
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, showTitle && React.createElement(SiteMenuTitle, null, t('Social Media')), order.map(function (type) {
    return links[type] && React.createElement(My.Item, {
      onClick: handleClick,
      href: links[type],
      iconComponent: ICONS[type],
      label: LABELS[type],
      key: type
    });
  }));
});
FollowMenu.cls = cls;
FollowMenu.defaultProps = FollowMenuDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;